<template>
  <div class="flex">
    <div class="left">
      <el-tree
			  default-expand-all
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        @check="selectChange"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="resourceCheckedKey"
        :props="defaultProps">
      </el-tree>
    </div>
    <div class="right">
      <Table ref="table"
             :perDatas="perDatas"
             :outPerDatas="outPerDatas"
             :state="state"
             :payGroupId="payGroupId"
             :batchId="batchId"
             :templateId="templateId"
             :orgId="orgId"
             :taxType="taxType"
             :wageMonth="wageMonth"
             :socMonth="socMonth"
             :taxMonth="taxMonth"
             :payWay="payWay"
             :isCompute="isCompute"
             :regionId="regionId"
             :cusId="cusId"
             v-on:personDatas="personClick"
             v-on:_getSalaryHistoryData="_getSalaryHistoryData">
      </Table>
    </div>
  </div>

</template>

<script>
  import Table from "@/views/wage/dataReadyTemplate/table.vue";
  import {queryOrgTreeSelect,getCusData} from "@/api/wage/payGroup";

  export default {
    name: "selectPerson",
    props:{
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      payGroupId:{
        type:Number,
        default:0
      },
      batchId:{
        type:Number,
        default:0
      },
      templateId:{
        type:Number,
        default:0
      },
      orgId:{
        type:Number,
        default:0
      },
      // cusId:{
      //   type:String,
      //   default:"",
      // },
      wageMonth:{
        type:String,
        default:''
      },
      regionId:{
        type:String,
        default:''
      },
      socMonth:{
        type:String,
        default:''
      },
      taxMonth:{
        type:String,
        default:''
      },
      payWay:{
        type:String,
        default:''
      },
      isCompute:{
        type:String,
        default:''
      },
      taxType:{
        type:Number,
        default:0
      },
      outPerDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      title: {
        type: String,
        default: () => (
          ''
        )
      },
      state: {
        type: String,
        default: '',
      },

    },
    created(){
      console.log("数机构数据fangfa------");
      console.log("已存在选取人员数据------",this.perDatas);
      console.log("已存在排除人员数据------",this.outPerDatas);
      this._getCusData();
     // this._queryOrgTreeSelect();
    },
    components:{Table},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'orgName'
        },
        orgMaps:{},
        treeData:[],
        orgIds:[],
        // state:true,
        cusId:''
      };
    },
    methods:{
      _queryOrgTreeSelect(cusId){
        console.log("this.cusId------",this.cusId);
        queryOrgTreeSelect(this.cusId).then((res) => {
          this.treeData = res.data;
          console.log("数据准备页面机构数组--this.treeData----",this.treeData);
          const arr = [];
          for(var i= 0;i < res.data.length;i++){
              arr.push(res.data[i].id)
          }
          this.$refs.tree.setCheckedKeys(arr);
          console.log("查询机构数选择~~~~~~~~arr==",arr)
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        });
      },
      selectChange(){
        this.orgIds = this.$refs.tree.getCheckedKeys();
        console.log("选择机构ids------",this.orgIds);
        this.$refs.table._getListpage(this.orgIds);
      },
      personClick(e){
        this.$emit('personDatas',e);
      },
      _getSalaryHistoryData(){
        this.$emit('_getSalaryHistoryData');//调用父类刷新方法
      },
        _getCusData(){
        getCusData().then((res) => {
          console.log('获取当前客户Id：', res.data.data.cusId);
          this.cusId= res.data.data.cusId;
          this._queryOrgTreeSelect(this.cusId);
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        });
      },

    }
  };
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .flex>div{
    height: calc(90vh - 150px);

  }
  .flex>div:nth-of-type(1){
    width: 250px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
    margin-right:20px;
    overflow: auto;
  }
  .flex>div:nth-of-type(2){
    width: calc(100% - 255px);
  }
</style>
